import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3731e4a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  style: {"height":"100%"}
}
const _hoisted_2 = { class: "ss-side-empresa" }
const _hoisted_3 = { class: "ss-side-identificao-empresa" }
const _hoisted_4 = {
  key: 0,
  class: "ss-side-multi-empresas"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { style: {"margin-left":"8px"} }
const _hoisted_7 = {
  key: 1,
  style: {"height":"40px"}
}
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 4,
  class: "ant-row"
}
const _hoisted_14 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-24",
  style: {"padding-top":"5px"}
}
const _hoisted_15 = { class: "fonte-peso-400" }
const _hoisted_16 = {
  class: "ant-row ss-alinhar-centro",
  style: {"margin-top":"5px","margin-bottom":"50px"}
}
const _hoisted_17 = {
  key: 0,
  style: {"margin-right":"8px","margin-top":"5px"}
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 0,
  style: {"margin-right":"8px","margin-top":"5px"}
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "ss-menu-mobile" }
const _hoisted_23 = { style: {"position":"absolute","width":"100%","bottom":"25px"} }
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  class: "ant-row",
  style: {"background-color":"rgb(255, 255, 255)","height":"60px !important","box-shadow":"0px -4px 4px 0px rgba(99, 99, 99, 0.58)"}
}
const _hoisted_26 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_27 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_28 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_29 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_30 = {
  key: 2,
  class: "ss-menu-corpo"
}
const _hoisted_31 = { class: "ant-row ss-titulo-menu" }
const _hoisted_32 = {
  style: {"padding-bottom":"10px"},
  class: "ant-col ant-col-xs-20 ant-col-xs-20"
}
const _hoisted_33 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_34 = { class: "ant-row" }
const _hoisted_35 = {
  class: "ant-row",
  style: {"padding-bottom":"5px","margin-bottom":"15px"}
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"5px"} }, "Deslogar", -1))
const _hoisted_37 = {
  class: "ant-row",
  style: {"height":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_notificacoes_desktop = _resolveComponent("notificacoes-desktop")!
  const _component_meus_atalhos = _resolveComponent("meus-atalhos")!
  const _component_meus_atalhos_desktop = _resolveComponent("meus-atalhos-desktop")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_notificacoes_mobile = _resolveComponent("notificacoes-mobile")!
  const _component_meus_atalhos_mobile = _resolveComponent("meus-atalhos-mobile")!
  const _component_menu_mobile_grade = _resolveComponent("menu-mobile-grade")!
  const _component_menu_mobile_bolhas = _resolveComponent("menu-mobile-bolhas")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _component_sobre_modal = _resolveComponent("sobre-modal")!

  return (_ctx.storeSistema.state.carregando)
    ? (_openBlock(), _createBlock(_component_loading, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(), _createBlock(_component_a_layout, {
          key: 'LAY-EMP-OPERACAO-' + _ctx.storeSistema.state.empresaEmOperacao,
          class: _normalizeClass(_ctx.storeSistema.state.layoutMobile?'ss-layout-mobile':'')
        }, {
          default: _withCtx(() => [
            (!_ctx.storeSistema.state.layoutMobile)
              ? (_openBlock(), _createBlock(_component_a_layout_sider, {
                  key: 0,
                  class: "ss-side-bar",
                  style: {"background":"#fff"},
                  "collapsed-width": _ctx.storeSistema.state.larguraTela < 990 ? 0 : 50,
                  collapsed: _ctx.collapsed,
                  "onUpdate:collapsed": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.collapsed) = $event)),
                  trigger: null,
                  collapsible: ""
                }, {
                  default: _withCtx(() => [
                    ((!_ctx.storeSistema.getters.menuCollapse()))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.storeSistema.getters.dadosIdentificacaoEmpresa()), 1)
                          ]),
                          ((_ctx.storeSistema.state.multiEmpresas))
                            ? (_openBlock(), _createBlock(_component_a_dropdown, {
                                key: 0,
                                trigger: ['click']
                              }, {
                                overlay: _withCtx(() => [
                                  _createVNode(_component_a_menu, null, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeSistema.state.empresasDisponiveis, (empresa) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, {
                                          key: empresa.codigoEmpresa
                                        }, [
                                          (empresa.codigoEmpresa !== _ctx.storeSistema.state.empresaEmOperacao.codigoEmpresa)
                                            ? (_openBlock(), _createBlock(_component_a_menu_item, { key: 0 }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("span", {
                                                    onClick: ($event: any) => (_ctx.definirEmpresaEmOperacao(empresa)),
                                                    style: {"display":"inline-flex","align-items":"center","color":"#000"}
                                                  }, [
                                                    _createElementVNode("b", null, _toDisplayString(_ctx.montarApresentacaoEmpresa(empresa)), 1),
                                                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.montarApresentacaoCpfCnpjEmpresa(empresa)), 1)
                                                  ], 8, _hoisted_5)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      }), 128))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  ((!_ctx.storeSistema.getters.menuCollapse()))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                        _createVNode(_component_icone, {
                                          style: {"font-size":"14px","margin-right":"6px"},
                                          class: "",
                                          nome: "empresa"
                                        }),
                                        _createTextVNode(" Gerenciar outra Empresa")
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createElementBlock("div", _hoisted_7)),
                    (_ctx.storeSistema.getters.menuCollapse())
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 2,
                          class: "trigger",
                          style: {"width":"100%"},
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.atualizarCollapsed && _ctx.atualizarCollapsed(...args)))
                        }, [
                          _createVNode(_component_icone, {
                            style: {"font-size":"20px"},
                            class: "ss-menu-collapsed",
                            nome: "menu-expandido"
                          })
                        ]))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 3,
                          class: "trigger",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.atualizarCollapsed && _ctx.atualizarCollapsed(...args)))
                        }, [
                          _createVNode(_component_icone, {
                            style: {"margin-right":"5px","font-size":"16px"},
                            class: "ss-menu-collapse",
                            nome: "menu-recolhido"
                          })
                        ])),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        (_ctx.storeSistema.getters.menuCollapse())
                          ? (_openBlock(), _createBlock(_component_a_avatar, {
                              key: 0,
                              size: 32,
                              class: "ss-sombra-suave"
                            }, {
                              icon: _withCtx(() => [
                                (_ctx.UtilitarioGeral.valorValido(_ctx.storeSistema.getters.imagemUsuarioAutenticado()))
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: _ctx.storeSistema.getters.imagemUsuarioAutenticado()
                                    }, null, 8, _hoisted_10))
                                  : (_openBlock(), _createBlock(_component_icone, {
                                      key: 1,
                                      nome: "usuario",
                                      style: {"margin-top":"7px"}
                                    }))
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_a_avatar, {
                              key: 1,
                              size: 128,
                              class: "ss-sombra-suave"
                            }, {
                              icon: _withCtx(() => [
                                (_ctx.UtilitarioGeral.valorValido(_ctx.storeSistema.getters.imagemUsuarioAutenticado()))
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: _ctx.storeSistema.getters.imagemUsuarioAutenticado()
                                    }, null, 8, _hoisted_11))
                                  : (_openBlock(), _createBlock(_component_icone, {
                                      key: 1,
                                      nome: "usuario",
                                      style: {"margin-top":"30px"}
                                    }))
                              ]),
                              _: 1
                            })),
                        _createVNode(_component_a_spin, {
                          spinning: _ctx.state.carregandoImagem,
                          style: {"margin-top":"-60px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_upload, {
                              "show-upload-list": false,
                              multiple: false,
                              accept: 'image/*',
                              "before-upload": _ctx.alterarAvatar
                            }, {
                              default: _withCtx(() => [
                                (!_ctx.storeSistema.getters.menuCollapse())
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      class: "ss-editar-avatar",
                                      disabled: _ctx.state.carregandoImagem
                                    }, [
                                      _createVNode(_component_icone, { nome: "editar" })
                                    ], 8, _hoisted_12))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["before-upload"])
                          ]),
                          _: 1
                        }, 8, ["spinning"])
                      ])
                    ]),
                    (!_ctx.storeSistema.getters.menuCollapse())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.storeSistema.state.dadosUsuarioAutenticado.nome), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", {
                        class: _normalizeClass(_ctx.storeSistema.getters.menuCollapse() ? 'ant-col ant-col-xs-6 ant-col-xl-24 ss-alinhar-centro' : 'ant-col ant-col-xs-24 ant-col-xl-4')
                      }, [
                        _createVNode(_component_router_link, {
                          title: "Home",
                          class: "ss-menu-recursos",
                          to: { name: 'MinhaDashboard' }
                        }, {
                          default: _withCtx(() => [
                            (_ctx.storeSistema.getters.menuCollapse())
                              ? (_openBlock(), _createBlock(_component_icone, {
                                  key: 0,
                                  style: {"margin-right":"8px","margin-top":"5px","font-size":"16px"},
                                  nome: "home"
                                }))
                              : (_openBlock(), _createBlock(_component_icone, {
                                  key: 1,
                                  style: {"margin-right":"5px","font-size":"16px"},
                                  nome: "home"
                                }))
                          ]),
                          _: 1
                        })
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(_ctx.storeSistema.getters.menuCollapse() ? 'ant-col ant-col-xs-6 ant-col-xl-24 ss-alinhar-centro' : 'ant-col ant-col-xs-24 ant-col-xl-4')
                      }, [
                        (_ctx.storeSistema.getters.menuCollapse())
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createVNode(_component_notificacoes_desktop)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              _createVNode(_component_notificacoes_desktop)
                            ]))
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(_ctx.storeSistema.getters.menuCollapse() ? 'ant-col ant-col-xs-6 ant-col-xl-24 ss-alinhar-centro' : 'ant-col ant-col-xs-24 ant-col-xl-4')
                      }, [
                        _createVNode(_component_router_link, {
                          title: "Agenda",
                          class: "ss-menu-recursos",
                          to: { name: 'Agenda' }
                        }, {
                          default: _withCtx(() => [
                            (_ctx.storeSistema.getters.menuCollapse())
                              ? (_openBlock(), _createBlock(_component_icone, {
                                  key: 0,
                                  style: {"margin-right":"8px","margin-top":"5px","font-size":"16px"},
                                  nome: "agenda"
                                }))
                              : (_openBlock(), _createBlock(_component_icone, {
                                  key: 1,
                                  style: {"margin-right":"5px","font-size":"16px"},
                                  nome: "agenda"
                                }))
                          ]),
                          _: 1
                        })
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(_ctx.storeSistema.getters.menuCollapse() ? 'ant-col ant-col-xs-6 ant-col-xl-24 ss-alinhar-centro' : 'ant-col ant-col-xs-24 ant-col-xl-4')
                      }, [
                        (_ctx.storeSistema.getters.menuCollapse())
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createVNode(_component_meus_atalhos)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createVNode(_component_meus_atalhos_desktop)
                            ]))
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(_ctx.storeSistema.getters.menuCollapse() ? 'ant-col ant-col-xs-6 ant-col-xl-24 ss-alinhar-centro' : 'ant-col ant-col-xs-24 ant-col-xl-4')
                      }, [
                        _createElementVNode("a", {
                          class: "ss-menu-recursos",
                          title: "Sobre o NeoX",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.abrirSobre && _ctx.abrirSobre(...args)))
                        }, [
                          (_ctx.storeSistema.getters.menuCollapse())
                            ? (_openBlock(), _createBlock(_component_icone, {
                                key: 0,
                                style: {"margin-right":"8px","font-size":"16px"},
                                nome: "interrogacao"
                              }))
                            : (_openBlock(), _createBlock(_component_icone, {
                                key: 1,
                                style: {"margin-right":"5px","font-size":"16px"},
                                nome: "interrogacao"
                              }))
                        ])
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(_ctx.storeSistema.getters.menuCollapse()? 'ant-col ant-col-xs-6 ant-col-xl-24 ss-alinhar-centro' : 'ant-col ant-col-xs-24 ant-col-xl-4')
                      }, [
                        _createElementVNode("span", {
                          title: "Deslogar",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.deslogar && _ctx.deslogar(...args))),
                          class: "ss-menu-recursos"
                        }, [
                          (_ctx.storeSistema.getters.menuCollapse())
                            ? (_openBlock(), _createBlock(_component_icone, {
                                key: 0,
                                style: {"margin-right":"8px","margin-top":"5px","font-size":"16px"},
                                nome: "deslogar"
                              }))
                            : (_openBlock(), _createBlock(_component_icone, {
                                key: 1,
                                style: {"margin-right":"5px","font-size":"16px"},
                                nome: "deslogar"
                              }))
                        ])
                      ], 2)
                    ]),
                    _createVNode(_component_a_menu, {
                      theme: "light",
                      mode: "vertical",
                      triggerSubMenuAction: "click"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeSistema.state.menus, (menu) => {
                          return (_openBlock(), _createBlock(_component_a_sub_menu, {
                            key: menu.codigo
                          }, {
                            title: _withCtx(() => [
                              _createVNode(_component_icone, {
                                style: _normalizeStyle('font-size:16px;color:' + menu.cor + ';margin-right: 5px'),
                                nome: menu.icone
                              }, null, 8, ["style", "nome"]),
                              _withDirectives(_createElementVNode("span", { class: "ss-menu-modulo" }, _toDisplayString(menu.titulo), 513), [
                                [_vShow, (!_ctx.storeSistema.getters.menuCollapse())]
                              ])
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.itens, (menuItem) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: 'pmi'+menuItem.codigo
                                }, [
                                  ((menuItem.tipoMenuItem === 1))
                                    ? (_openBlock(), _createBlock(_component_a_menu_item, {
                                        key: 'mi' + menuItem.codigo
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_router_link, {
                                            to: { path: menuItem.link ? `/${menuItem.link}` : '' }
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("span", null, _toDisplayString(menuItem.titulo), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["to"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : ((menuItem.tipoMenuItem === 2))
                                      ? (_openBlock(), _createBlock(_component_a_sub_menu, {
                                          key: 'mi' + menuItem.codigo
                                        }, {
                                          title: _withCtx(() => [
                                            _createElementVNode("span", null, _toDisplayString(menuItem.titulo), 1)
                                          ]),
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem.itens, (subMenuItem) => {
                                              return (_openBlock(), _createBlock(_component_a_menu_item, {
                                                key: 'mi' + subMenuItem.codigo
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_router_link, {
                                                    to: { path: subMenuItem.link ? `/${subMenuItem.link}` : '' }
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("span", null, _toDisplayString(subMenuItem.titulo), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["to"])
                                                ]),
                                                _: 2
                                              }, 1024))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("img", {
                      class: _normalizeClass(_ctx.storeSistema.getters.menuCollapse() ? 'ss-logo-neox collapse' : 'ss-logo-neox'),
                      src: _ctx.storeSistema.getters.menuCollapse() ? '/static/img/ss-logo.png' : '/static/img/ss-logo-horizontal-v2.png'
                    }, null, 10, _hoisted_21)
                  ]),
                  _: 1
                }, 8, ["collapsed-width", "collapsed"]))
              : _createCommentVNode("", true),
            _createVNode(_component_a_layout, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_layout_content, null, {
                  default: _withCtx(() => [
                    ((_ctx.storeSistema.state.layoutMobile))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("button", {
                                style: {},
                                class: "ant-btn ss-botao-principal-mobile",
                                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.abrirMenuModulos && _ctx.abrirMenuModulos(...args)))
                              }, [
                                _createElementVNode("img", {
                                  style: {"width":"45px","height":"45px"},
                                  src: require(`/public/static/img/ss-simbolo-logo.png`)
                                }, null, 8, _hoisted_24)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, [
                                _createVNode(_component_router_link, {
                                  class: "ss-botao-mobile",
                                  to: { name: 'MinhaDashboard' },
                                  onClick: _ctx.fecharMenuRecursos
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_icone, {
                                      class: "ss-icone-botao-mobile",
                                      nome: "home"
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _createElementVNode("div", _hoisted_27, [
                                _createVNode(_component_notificacoes_mobile, {
                                  visualizar: _ctx.state.exibirNotificacoes,
                                  "onUpdate:visualizar": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.exibirNotificacoes) = $event)),
                                  onAbrirNotificacoes: _ctx.abrirNotificacoes
                                }, null, 8, ["visualizar", "onAbrirNotificacoes"])
                              ]),
                              _createElementVNode("div", _hoisted_28, [
                                _createVNode(_component_router_link, {
                                  class: "ss-botao-mobile",
                                  style: {"margin-right":"-30px"},
                                  to: { name: 'Agenda' },
                                  onClick: _ctx.fecharMenuRecursos
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_icone, {
                                      class: "ss-icone-botao-mobile",
                                      nome: "agenda"
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _createElementVNode("div", _hoisted_29, [
                                _createVNode(_component_meus_atalhos_mobile, {
                                  visualizar: _ctx.state.exibirFavoritos,
                                  "onUpdate:visualizar": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.exibirFavoritos) = $event)),
                                  onAbrirFavoritos: _ctx.abrirFavoritos
                                }, null, 8, ["visualizar", "onAbrirFavoritos"])
                              ])
                            ])
                          ]),
                          (_ctx.state.menuGrade && _ctx.state.exibirModulos)
                            ? (_openBlock(), _createBlock(_component_menu_mobile_grade, {
                                key: 0,
                                onAbrirMenu: _ctx.abrirMenuRecursos
                              }, null, 8, ["onAbrirMenu"]))
                            : (_openBlock(), _createBlock(_component_menu_mobile_bolhas, {
                                key: 1,
                                exibir: _ctx.state.exibirModulos,
                                "onUpdate:exibir": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.exibirModulos) = $event)),
                                onAbrirMenu: _ctx.abrirMenuRecursos
                              }, null, 8, ["exibir", "onAbrirMenu"])),
                          (_ctx.state.exibirMenuRecursos)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeSistema.state.menus, (menu) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: menu.codigoModulo
                                  }, [
                                    (menu.codigoModulo === _ctx.state.menuSelecionado)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createElementVNode("div", _hoisted_31, [
                                            _createElementVNode("div", _hoisted_32, [
                                              _createElementVNode("span", null, _toDisplayString(menu.titulo), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_33, [
                                              _createElementVNode("a", {
                                                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.voltarMenuModulos && _ctx.voltarMenuModulos(...args)))
                                              }, [
                                                _createVNode(_component_icone, {
                                                  class: "ss-icone-fechar",
                                                  nome: "voltar"
                                                })
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_34, [
                                            _createVNode(_component_a_menu, {
                                              style: {"border-radius":"10px"},
                                              theme: "light",
                                              mode: "inline"
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.itens, (menuItem) => {
                                                  return (_openBlock(), _createElementBlock(_Fragment, {
                                                    key: 'pmi'+menuItem.codigo
                                                  }, [
                                                    ((menuItem.tipoMenuItem === 1))
                                                      ? (_openBlock(), _createBlock(_component_a_menu_item, {
                                                          style: {"font-size":"large","height":"40px"},
                                                          key: 'mi'+menuItem.codigo
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_router_link, {
                                                              to: { path: menuItem.link ? `/${menuItem.link}` : '' },
                                                              onClick: _ctx.fecharMenuRecursos
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createElementVNode("span", null, _toDisplayString(menuItem.titulo), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["to", "onClick"])
                                                          ]),
                                                          _: 2
                                                        }, 1024))
                                                      : ((menuItem.tipoMenuItem === 2))
                                                        ? (_openBlock(), _createBlock(_component_a_sub_menu, {
                                                            style: {"font-size":"larger"},
                                                            key: 'mi'+menuItem.codigo
                                                          }, {
                                                            title: _withCtx(() => [
                                                              _createElementVNode("span", null, _toDisplayString(menuItem.titulo), 1)
                                                            ]),
                                                            default: _withCtx(() => [
                                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem.itens, (subMenuItem) => {
                                                                return (_openBlock(), _createBlock(_component_a_menu_item, {
                                                                  style: {"font-size":"large"},
                                                                  key: 'mi'+subMenuItem.codigo
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_router_link, {
                                                                      to: { path: subMenuItem.link ? `/${subMenuItem.link}` : '' },
                                                                      onClick: _ctx.fecharMenuRecursos
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createElementVNode("span", null, _toDisplayString(subMenuItem.titulo), 1)
                                                                      ]),
                                                                      _: 2
                                                                    }, 1032, ["to", "onClick"])
                                                                  ]),
                                                                  _: 2
                                                                }, 1024))
                                                              }), 128))
                                                            ]),
                                                            _: 2
                                                          }, 1024))
                                                        : _createCommentVNode("", true)
                                                  ], 64))
                                                }), 128)),
                                                (menu.codigoModulo === 1)
                                                  ? (_openBlock(), _createBlock(_component_a_switch, {
                                                      key: 0,
                                                      style: {"margin-left":"5px","margin-bottom":"10px"},
                                                      checked: _ctx.state.menuGrade,
                                                      "onUpdate:checked": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.menuGrade) = $event)),
                                                      "checked-children": "Menu de Grade",
                                                      "un-checked-children": "Menu de Bolhas",
                                                      onChange: _ctx.alterarTipoMenu
                                                    }, null, 8, ["checked", "onChange"]))
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_35, [
                                                  (menu.codigoModulo === 1)
                                                    ? (_openBlock(), _createElementBlock("a", {
                                                        key: 0,
                                                        style: {"font-size":"24px","padding-left":"10px"},
                                                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.deslogar && _ctx.deslogar(...args)))
                                                      }, [
                                                        _createVNode(_component_icone, {
                                                          style: {"padding-top":"5px"},
                                                          nome: "deslogar"
                                                        }),
                                                        _hoisted_36
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ])
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_37, [
                      _createVNode(_component_router_view)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"])),
        (!_ctx.storeSistema.state.carregando)
          ? (_openBlock(), _createBlock(_component_sobre_modal, {
              key: 0,
              visivel: _ctx.state.exibirSobre,
              "onUpdate:visivel": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.exibirSobre) = $event))
            }, null, 8, ["visivel"]))
          : _createCommentVNode("", true)
      ]))
}